import React from "react";

export type IFabricIconProps = {};

const FabricIcon: React.FC<IFabricIconProps> = ({}) => {
 return (
  <svg
   xmlns="http://www.w3.org/2000/svg"
   width={52.582}
   height={51.779}
   viewBox="0 0 52.582 51.779"
  >
   <g data-name="Group 5672">
    <g data-name="Group 5671" fill="#7c7c7c">
     <path
      data-name="Path 379"
      d="M47.241 26.153a45.478 45.478 0 003.806-6.1l1.535-2.984-3.3.6a17.352 17.352 0 01-2.044.237 45.478 45.478 0 003.806-6.1l1.533-2.98-3.3.6a17.522 17.522 0 01-13-2.7L26.27.004 0 17.647l6.136 4.121L0 25.89l6.136 4.121L0 34.132l26.27 17.647 9.65-6.485a45.742 45.742 0 0015.13-17l1.531-2.979-3.3.6a17.4 17.4 0 01-2.04.238zM5.912 17.647L26.27 3.973l8.175 5.491a20.758 20.758 0 0012.146 3.551 42.446 42.446 0 01-12.51 13.058l-7.811 5.248zm28.169 24.91l-7.811 5.247L5.912 34.132l3.18-2.143L26.27 43.528l9.65-6.485a45.549 45.549 0 008.7-7.619c.659.048 1.319.074 1.978.061a42.425 42.425 0 01-12.517 13.073zm0-8.242l-7.811 5.249L5.912 25.89l3.18-2.143L26.27 35.286l9.65-6.485a45.549 45.549 0 008.7-7.619c.659.048 1.319.074 1.978.061a42.425 42.425 0 01-12.517 13.072z"
     />
     <path data-name="Rectangle 1573" d="M13.082 15.763h3.297v3.297h-3.297z" />
     <path data-name="Rectangle 1574" d="M19.676 12.466h3.297v3.297h-3.297z" />
     <path data-name="Rectangle 1575" d="M24.622 9.169h3.297v3.297h-3.297z" />
     <path data-name="Rectangle 1576" d="M19.676 19.06h3.297v3.297h-3.297z" />
     <path data-name="Rectangle 1577" d="M24.622 24.005h3.297v3.297h-3.297z" />
     <path data-name="Rectangle 1578" d="M26.27 15.763h3.297v3.297H26.27z" />
     <path data-name="Rectangle 1579" d="M31.216 12.466h3.297v3.297h-3.297z" />
     <path data-name="Rectangle 1580" d="M31.216 19.06h3.297v3.297h-3.297z" />
    </g>
   </g>
  </svg>
 );
};

export { FabricIcon };
